import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AppService} from "../../../../../common";
import {Subscription} from "rxjs";

const IDTAG_MIN_LENGTH = 6;
const IDTAG_MAX_LENGTH = 8;

@Component({
  selector: 'app-idtag',
  standalone: false,
  templateUrl: './idtag.component.html',
  styleUrls: ['./idtag.component.scss']
})
export class IdtagComponent implements OnInit {

  idtag: string = "";
  error: boolean = false;
  success: boolean = false;
  subscription: Subscription = null;

  @Output() validTag = new EventEmitter<string>();

  constructor(private appService: AppService) { }

  ngOnInit(): void {
    this.subscription = this.appService.load().subscribe(({host}) => {
      if (host) {
        this.success = true;
        this.error = false;
        this.validTag.emit(this.idtag.toLowerCase());
      } else {
        this.success = false;
        if (this.idtag.length >= IDTAG_MAX_LENGTH) {
          this.error = true;
        }
      }
    })
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onKey(event: KeyboardEvent) {
    let key = event.key;
    if (key == 'Backspace') {
      this.idtag = this.idtag.substr(0, this.idtag.length - 1);
      this.error = false;
    } else if ( key == 'Delete' ) {
      this.idtag = '';
      this.error = false;
    } else if ( this.idtag.length < IDTAG_MAX_LENGTH ) {
      key = key.toUpperCase();
      if ('ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'.indexOf(key) > -1)
        this.idtag += key;
        this.error = false;
    }
    if (this.idtag.length >= IDTAG_MIN_LENGTH) {
      // try to set the table, we will learn about the result in subscription
      this.appService.setTable(this.idtag.toLowerCase());
    }
    return false; // return false to stop propagation
  }

}
